<h3>Confirm Task Sequence</h3>
<p>This job has a flexible sequencing. Arrange tasks in the order you plan to complete them.</p>

<h4>Tasks</h4>
<div cdkDropList [cdkDropListData]="tasks" (cdkDropListDropped)="drop($event)">
  <div *ngFor="let task of tasks; let taskIndex = index" cdkDrag class="my-2">
    <schedule-task-sequence-task
      [task]="task"
      [isUpButtonEnabled]="taskIndex != 0"
      [isDownButtonEnabled]="taskIndex != tasks.length - 1"
      (onShiftPosition)="shiftTaskPosition(taskIndex, $event)"
    >
    </schedule-task-sequence-task>
  </div>
</div>
